export default {
  forgot: {
    tentative: {
      1: 'Il vous reste 2 tentatives',
      2: "Ceci est votre dernière tentative, votre compte sera bloqué en cas d'erreur",
      3: 'Votre compte est verrouillé, veuillez contacter le CIEM',
    },
    userNotFound: 'Utilisateur non trouvé',
    secretQuestionNotFound: 'Question secrète non trouvée',
    confirmationChange: 'Mot de passe changé avec succés',
    confirmationMailSent: 'Email envoyé',
    confirmationSMSSent: 'SMS envoyé',
    expire: {
      title: 'Lien expiré',
      text: 'Ce lien est expiré, veuillez vous rendre dans la section mot de passe oublié pour refaire une demande de changement de mot de passe.',
    },
  },
}
